/* eslint-disable react-hooks/exhaustive-deps */
// @ts-nocheck
import React, { useEffect, useState } from "react";
import Topbar from "../../components/Topbar/Topbar";
import { arrow_icon } from "../../assets/img";
import { useLocation, useNavigate } from "react-router-dom";
import CurrentStepCard from "./CurrentStepCard";
import { get, post } from "../../Services/ApiHandler";
import { RZP_KEY, URLS } from "../../Services/Constant";
import { useRazorpay } from "react-razorpay";
import { toast } from "react-toastify";
import { checkPermission } from "../redux/api/PermissionManager";

const PropertyMMCEdit = () => {
  const admin = JSON.stringify(localStorage.getItem("admin_details"));
  const navigate = useNavigate();
  const location = useLocation();
  const [isPaymentDis, setIsPaymentDis] = useState(false);
  const owner_id = location?.state?.owner_id;
  const id = location?.state?.id;
  const { error, Razorpay } = useRazorpay();
  const [data, setData] = useState({
    amount: "",
    gst: "",
    plan: "",
    total: "",
    policies: [],
    pointNames: [],
    plan_id: "",
    category: "",
  });
  useEffect(() => {
    viewMmc();
  }, []);

  useEffect(() => {
    console.log("error accured", error);
    if (error) {
      toast.error(error);
    }
  }, [error]);
  const viewMmc = async () => {
    const res = await get(URLS.MMC_MASTER + `?property_id=${id}`);
    if (res?.status === "success") {
      let d = res?.data;
      console.log("ADJJJJJJJJJJJJJJ", d.is_trial_available);
      setData({
        amount: d.is_trial_available ? 0 : d?.amount,
        gst: d?.gst,
        plan: d.is_trial_available ? d.first_time_offer_days : d?.plan_days,
        total: d.is_trial_available ? 0 : d?.total_amount,
        pointNames: d?.points,
        policies: d?.terms_conditions,
        plan_id: d?.plan_id,
        category: d?.category_id,
      });
    }
  };

  // const paymentInitiate = async () => {
  //   setIsPaymentDis(true);
  //   const res = await post(`${URLS.CREATE_MMC}${owner_id}/${id}/`);

  //   if (res?.status === "success") {
  //     const d = res?.data;
  //     const RazorpayOrderOptions = {
  //       key: RZP_KEY,
  //       image:
  //         "https://frontend.newvow.vowstays.com/static/media/logo-icon.adcfba19588c3cc82c9a.png",
  //       amount: Number(d?.total_amount) * 100, // Amount in paise
  //       currency: "INR",
  //       name: "Vow",
  //       description: "Monthly Subscription",
  //       subscription_id: d?.razorpay_subscription_id,
  //       handler: (response) => {
  //         console.log("razorpay response", response);
  //         confirmPayment(response);
  //         alert("Payment Successful!");
  //       },
  //       prefill: {
  //         name: admin?.name,
  //         email: admin?.email,
  //         contact: admin?.mobile,
  //       },
  //       theme: {
  //         color: "#AE55F5",
  //       },
  //     };
  //     const razorpayInstance = new Razorpay(RazorpayOrderOptions);
  //     razorpayInstance.open();
  //   }
  // };

  const paymentInitiate = async () => {
    setIsPaymentDis(true);
    const res = await post(`${URLS.CREATE_MMC}${owner_id}/${id}/`);

    if (res?.status === "success") {
      const d = res?.data;
      const RazorpayOrderOptions = {
        key: RZP_KEY,
        image:
          "https://frontend.newvow.vowstays.com/static/media/logo-icon.adcfba19588c3cc82c9a.png",
        amount: Number(d?.total_amount) * 100,
        currency: "INR",
        name: "Vow",
        description: "Monthly Subscription",
        subscription_id: d?.razorpay_subscription_id,
        handler: (response) => {
          console.log("razorpay response", response);
          confirmPayment(response);
          alert("Payment Successful!");
        },
        modal: {
          // ✅ Re-enable button if user dismisses/closes the Razorpay modal
          ondismiss: () => {
            setIsPaymentDis(false);
            toast.info("Payment cancelled.");
          },
        },
        prefill: {
          name: admin?.name,
          email: admin?.email,
          contact: admin?.mobile,
        },
        theme: {
          color: "#AE55F5",
        },
      };

      const razorpayInstance = new Razorpay(RazorpayOrderOptions);

      // ✅ Re-enable button on Razorpay payment failure
      razorpayInstance.on("payment.failed", (response) => {
        console.error("Payment failed", response.error);
        toast.error(
          response.error.description || "Payment failed. Please try again.",
        );
        setIsPaymentDis(false);
      });

      razorpayInstance.open();
    } else {
      // ✅ Re-enable if the API call itself fails
      setIsPaymentDis(false);
    }
  };

  const confirmPayment = async ({
    razorpay_subscription_id,
    razorpay_signature,
    razorpay_payment_id,
  }) => {
    const payload = {
      success: "active",
      razorpay_payment_id: razorpay_payment_id,
      razorpay_signature: razorpay_signature,
      razorpay_subscription_id: razorpay_subscription_id,
    };

    const res = await post(URLS.VERIFY_MMC, payload);

    if (res?.status === "success") {
      // navigate("/overall-properties", { replace: true });
      navigate("/property-details", {
        state: {
          id: id,
          owner: owner_id,
          category_id: data.category,
        },
        replace: true,
      });
    }
    setIsPaymentDis(false);
  };
  return (
    <div>
      <Topbar header={"Properties"} subHead={"Requested"} />
      <CurrentStepCard />
      <div className="d-flex flex-wrap gap-5 my-5">
        <div className="col-md-5">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
            Amount
          </p>
          <input
            className="input-box"
            name="userName"
            value={data.amount}
            type="text"
            placeholder="Amount Name"
            disabled
          />
        </div>
        <div className="col-md-5">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
            GST %
          </p>
          <input
            className="input-box"
            name="userName"
            value={data.gst}
            type="text"
            placeholder="Gst %"
            disabled
          />
        </div>
        <div className="col-md-5">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
            Plan Days{" "}
          </p>
          <input
            className="input-box"
            name="userName"
            value={data.plan}
            type="text"
            placeholder="Plan Days"
            disabled
          />
        </div>
        <div className="col-md-5">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
            Total Amount{" "}
          </p>
          <input
            className="input-box"
            name="userName"
            value={data.total}
            type="text"
            placeholder="Total Amount "
            disabled
          />
        </div>
      </div>
      <div className="d-flex as-js gap-5 mt-5">
        <div className="col-md-5">
          <p className="f4 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
            Terms & Conditions{" "}
          </p>

          {data?.policies?.map((policy, index) => {
            return (
              <div className="d-flex as-js gap-3 my-3">
                <img src={arrow_icon} className="back-arrow" alt="" />
                <p className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 col-md-10">
                  {policy}
                </p>
              </div>
            );
          })}
        </div>
        <div className="col-md-5">
          <p className="f4 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
            Points
          </p>

          {data?.pointNames?.map((name, index) => {
            return (
              <div className="d-flex as-js gap-3 my-3">
                <img src={arrow_icon} className="back-arrow" alt="" />
                <p className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 col-md-10">
                  {name}
                </p>
              </div>
            );
          })}
        </div>
      </div>
      <div className="d-flex ac-je mt-5">
        {checkPermission("CAN-EDIT-MMC") && (
          <button
            onClick={paymentInitiate}
            className={`${isPaymentDis ? "dissubmit-btn" : "submit-btn"} f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 `}
            disabled={isPaymentDis}
          >
            Pay MMC
          </button>
        )}
      </div>
    </div>
  );
};

export default PropertyMMCEdit;
